import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // If the URL has a hash (e.g. /blog#faq), scroll to that element instead of
    // jumping to the top. Retry briefly in case the target renders just after navigation.
    if (hash) {
      const id = hash.slice(1);
      let tries = 0;
      const scrollToHash = () => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else if (tries++ < 20) {
          setTimeout(scrollToHash, 50);
        }
      };
      scrollToHash();
    } else {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    }
  }, [pathname, hash]);

  return null;
}
